// 서비스 이용약관
const ServiceTerms = `본 약관은 주식회사 퍼니즈(이하 "회사")가 제공하는 Castar 서비스(웹사이트, 모바일 애플리케이션 및 기타 관련 서비스 포함, 이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

본 약관에 동의하는 것은 본 약관의 모든 내용을 충분히 이해하고 수락함을 의미합니다.

제1조(목적)

본 약관은 회사가 제공하는 Castar 서비스 이용과 관련하여 회사와 이용자 간의 권리·의무 및 책임사항, 서비스 이용 조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.

제2조(약관의 효력 및 변경)

1. 본 약관은 이용자가 회원가입 시 "동의합니다" 버튼을 클릭함으로써 효력이 발생합니다.
2. 회사는 관련 법령(「전자상거래법」, 「정보통신망법」 등)을 위반하지 않는 범위에서 본 약관을 개정할 수 있습니다.
3. 회사가 약관을 변경할 경우, 변경 내용 및 적용일자를 명시하여 적용일 7일 전(이용자에게 불리한 경우 30일 전)부터 서비스 내 공지사항 또는 이메일 등으로 공지합니다.
4. 이용자가 변경된 약관에 대해 명시적으로 거부 의사를 표시하지 않을 경우, 변경된 약관에 동의한 것으로 간주합니다.

제3조(용어의 정의)

1. "서비스"란 회사가 제공하는 배우·제작사 매칭 플랫폼(Castar) 및 이에 수반되는 모든 기능을 말합니다.
2. "회원"이란 본 약관에 동의하고 회사와 이용계약을 체결한 자를 말합니다.
3. "배우 회원"이란 배우로 등록하여 포트폴리오를 생성·관리하고 캐스팅 서비스를 이용하는 회원을 말합니다.
4. "제작사 회원"이란 콘텐츠 제작사·영화사·프로덕션 등 제작 담당자로 가입한 회원을 말합니다.
5. "콘텐츠"란 회원이 서비스에 업로드한 사진, 영상, 프로필, 글 등 모든 자료를 의미합니다.
6. "유료 서비스"란 회사가 제공하는 정기구독, 포인트, 오디션 지원 기능 등 유료로 이용 가능한 서비스를 말합니다.

제4조(이용계약의 성립)

1. 이용계약은 이용자가 본 약관에 동의하고 회원가입 신청을 완료하면 성립합니다.
2. 회사는 다음 각 호에 해당하는 경우 회원가입을 거부하거나 유보, 취소 할 수 있습니다.
  - 허위 정보를 기재한 경우
  - 타인의 명의 또는 정보를 도용한 경우
  - 서비스 제공에 현저한 지장이 있다고 판단되는 경우
  - 법령 또는 회사 정책에 따라 부적절한 가입으로 판단되는 경우

제5조(회원 정보의 관리)

1. 회원은 자신의 계정 정보(ID, 비밀번호 등)를 스스로 관리할 책임이 있습니다.
2. 계정 도용, 무단 사용 등으로 인해 발생하는 손해는 회원 본인의 책임이며, 회사는 이에 대해 책임을 지지 않습니다.
3. 회원은 개인정보 변경 시 즉시 수정하여야 합니다.

제6조(서비스의 제공)

회사는 아래 서비스를 제공합니다.

1. 배우 포트폴리오 생성, 관리 및 열람 기능
2. 오디션 공고 열람 및 지원
3. 제작사–배우 간 매칭 및 커뮤니케이션 기능
4. 검색, 필터링, 추천 등 캐스팅 관련 기능
5. 유료 서비스(정기구독, 포인트 등) 제공
6. 고객 지원, 공지사항 전달 등 서비스 운영 기능

제7조(서비스의 변경 및 중단)

1. 회사는 서비스의 일부 또는 전부를 변경할 수 있으며, 필요한 경우 사전 공지합니다.
2. 다음 각 호의 경우 사전 공지 없이 서비스가 일시 중단될 수 있습니다.
  - 시스템 점검, 서버 교체 등 불가피한 경우
  - 천재지변, 정전 등 회사가 통제할 수 없는 사유
  - 해킹, 장애 등 긴급 조치가 필요한 경우

제8조(회원의 의무)

회원은 다음 행위를 하여서는 안 됩니다.

1. 허위 정보 등록
2. 타인의 프로필 또는 개인정보 도용
3. 불법 촬영물·저작권 침해 자료·음란물 게시
4. 폭언, 비방, 협박 등 상대방을 불쾌하게 하는 행위
5. 회사 서비스의 정상적 운영을 방해하는 행위
6. 상업적 광고, 스팸 메시지 전송
7. 법령 또는 공서양속에 위반되는 행위

회원이 위 항목을 위반할 경우 회사는 경고, 기능 제한, 게시물 삭제, 탈퇴 및 재가입 금지 조치 등을 취할 수 있습니다.

제9조(콘텐츠의 관리 및 저작권)

1. 회원이 업로드한 콘텐츠의 저작권은 회원에게 있으며, 회원은 회사가 아래 범위에서 콘텐츠를 이용하는 것에 동의합니다.
  - Castar 서비스 내 표시 및 노출
  - 배우–제작사 매칭을 위한 열람 제공
  - 서비스 운영, 품질 개선, 오류 분석
2. 회사는 회원의 사전 동의 없이 콘텐츠를 홍보·광고 등 외부 용도로 사용하지 않습니다.
3. 회원은 자신이 업로드한 콘텐츠가 타인의 저작권·초상권을 침해하지 않음을 보증합니다.

제10조(제작사 회원의 책임)

1. 제작사 회원은 오디션 공고의 내용, 조건, 진행, 촬영, 계약 등 모든 과정에 대해 단독 책임을 집니다.
2. 회사는 제작사와 배우 간의 계약 과정에 개입하지 않습니다.
3. 제작사는 공고의 허위 작성, 임금 미지급, 안전 문제 유발 등 불법행위 발생 시 모든 법적 책임을 부담합니다.

제11조(유료 서비스 및 결제)

1. 회사는 유료 서비스의 이용요금, 제공 방식, 환불 규정을 서비스 내에 명시합니다.
2. 회원이 결제를 진행하는 경우, 결제 금액·조건·환불 규정에 대해 동의한 것으로 간주합니다.
3. 결제 정보는 결제대행사를 통해 처리되며, 회사는 민감한 결제 정보를 직접 보관하지 않습니다.

제12조(환불 규정)

1. 환불 규정은 Castar 서비스의 '환불 정책'에 따르며, 회원은 사용 전 반드시 확인하여야 합니다.
2. 유료 서비스 이용 후 발생한 환불 요청은 정책에 따라 승인 또는 제한될 수 있습니다.
3. 환불 남용, 반복 악용 등의 행위가 확인되는 경우 회사는 계정 제한 또는 탈퇴 조치를 할 수 있습니다.

제13조(개인정보 보호)

1. 개인정보 처리와 관련된 모든 사항은 개인정보처리방침에 따릅니다.
2. 이용약관과 개인정보처리방침이 충돌할 경우, 개인정보처리방침을 우선합니다.

제14조(회사의 면책)

1. 제작사와 배우 간 발생한 모든 계약, 출연료 지급, 일정 조율, 현장 안전 문제 등에 대해 회사는 책임을 지지 않습니다.
2. 회원의 귀책으로 인해 발생한 손해에 대하여 회사는 책임을 지지 않습니다.
3. 천재지변, 장애, 통신사고 등 불가항력적 사유로 서비스 제공이 중단된 경우 회사는 책임을 지지 않습니다.

제15조(계약 해지 및 회원 탈퇴)

1. 회원은 언제든지 "탈퇴하기" 기능을 통해 이용계약을 해지할 수 있습니다.
2. 회사는 다음 각 호에 해당하는 경우 사전 통보 후 이용계약을 해지할 수 있습니다.
  - 불법 또는 약관 위반 행위를 반복하는 경우
  - 타인에게 피해를 주는 행위를 지속하는 경우
  - 명의 도용, 부정 결제 등 중대한 위반 행위
3. 이용계약 해지 시, 법령 및 개인정보처리방침에 따라 일부 정보는 일정 기간 동안 보관될 수 있습니다.

제16조(분쟁 해결 및 관할법원)

1. 서비스 이용과 관련하여 회사와 회원 간 분쟁이 발생하는 경우, 회사는 원활한 해결을 위해 성실히 협의합니다.
2. 협의가 이루어지지 않을 경우, 소송 관할은 회사 본사 소재지 관할 법원으로 합니다.

제17조(준거법)

본 약관은 대한민국 법률을 따릅니다.

"본인은 주식회사 퍼니즈의 Castar 서비스 이용약관(전문)을 확인하였으며, 이에 동의합니다."`;

export default ServiceTerms;
